/* eslint-disable no-underscore-dangle */
import { AuthProviderProps, UserManager } from 'oidc-react';
import { langcode } from 'translation';

let baseURL = '';
const apiPath = '/api';

export const exorLiveAdminLink =
  process.env.NODE_ENV === 'development'
    ? 'https://test.exorlive.com/app/#Admin'
    : 'https://exorlive.com/app/#Admin';

if (process.env.NODE_ENV === 'test') {
  baseURL = 'http://localhost:3010';
}

export function url(): string {
  return baseURL;
}

export function createURL(path: string): string {
  if (path.indexOf('/') !== 0)
    throw new Error(`Path '${path}' should be prefixed with a '/'`);
  return `${baseURL}${apiPath}${path}`;
}

const LOCATION = 'location';

const defaultEnv = {
  OAUTH_TENANT_ID: '8bf4401c-f9fc-4a52-bf72-aa95ab3b0157',
  OAUTH_CLIENT_ID: 'f2060415-1b70-4665-b2c8-7a2b71fc6cc5',
  OAUTH_URL: 'https://staging-auth.komp.family',
  CONTENT_PACK_ORG: 'ac861638-1ee8-11e9-94b8-cb309041931e',
};

const getWindow = () => {
  if (typeof window === 'undefined') {
    return {
      location: { origin: 'http://localhost:3000', pathname: '/' },
      localStorage: {
        getItem: () => null,
        setItem: () => {},
      },
      __ENV__: defaultEnv,
    };
  }
  return window;
};

const getEnv = () => {
  const win = getWindow();
  return win.__ENV__ || defaultEnv;
};

export const authProviderProps: AuthProviderProps = {
  onBeforeSignIn: () => {
    const win = getWindow();
    // save the path so we can redirect to it upon returning
    if (!['/logout', '/login'].includes(win.location.pathname)) {
      win.localStorage.setItem(LOCATION, win.location.pathname);
    }
  },
  autoSignIn: false,
};

export const userManager = new UserManager({
  authority: `${getEnv().OAUTH_URL}/.well-known/openid-configuration/${getEnv().OAUTH_TENANT_ID}`,
  client_id: getEnv().OAUTH_CLIENT_ID,
  redirect_uri: `${getWindow().location.origin}/oauth/callback`,
  scope: 'openid',
  response_type: 'code',
  loadUserInfo: false,
  silent_redirect_uri: `${getWindow().location.origin}/oauth/callback`,
  post_logout_redirect_uri: `${getWindow().location.origin}`,
  extraQueryParams: {
    locale: langcode,
  },
});
